module.exports = __webpack_public_path__ + "static/img/naturalCircle9.aa2b835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle9.svg
// module id = wtXv
// module chunks = 1